/**
 * 반입택배사 — 서버 `server/src/domain/carrier.ts` 의 사본이다. 한쪽을 고치면 다른 쪽도 고칠 것.
 *
 * 저장·전송은 코드로만 하고 표기는 언어 사전(`carrier.*`)이 정한다.
 * 시트에서 옮겨 온 옛 자유 입력이 남아 있을 수 있어 모르는 값은 번역하지 않고 그대로 보여 준다.
 */

export const CARRIERS = ["sagawa", "yamato"] as const
export type Carrier = (typeof CARRIERS)[number]

/** 접수 화면이 미리 골라 두는 택배사. 대부분 사가와로 들어온다 — 다르면 고쳐 고른다. */
export const DEFAULT_CARRIER: Carrier = "sagawa"

export function isCarrier(value: string): value is Carrier {
  return (CARRIERS as readonly string[]).includes(value)
}

export function carrierLabel(
  carrier: string | null,
  t: (key: string) => string,
): string | null {
  if (carrier === null || carrier === "") return null
  return isCarrier(carrier) ? t(`carrier.${carrier}`) : carrier
}
